import { render } from "./ResultsGrid.vue?vue&type=template&id=3f42f142&scoped=true"
import script from "./ResultsGrid.vue?vue&type=script&lang=js"
export * from "./ResultsGrid.vue?vue&type=script&lang=js"

import "./ResultsGrid.vue?vue&type=style&index=0&id=3f42f142&lang=scss"
import "./ResultsGrid.vue?vue&type=style&index=1&id=3f42f142&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3706327227/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f42f142"]])

export default __exports__